// Constants
import { VARIANTS } from '@openbank/ziniaweb-ui-components';
// Enumerations
import { AuthScenariosEnumeration } from '../enumerations/auth-scenarios.enumeration';

const AUTH_WATCHER_MODAL_COMPONENT_PROPS = {
    blocked: true,
    contentScrollArias: {
      'aria-label': 'Modal content scrollable',
    },
    open: true,
    maxWidth: '620px',
    variant: VARIANTS.ModalVariantType.DEFAULT,
  },
  AUTH_WATCHER_MODAL_TITLE_COMPONENT_PROPS = {
    showBuilder: false,
  },
  AUTH_WATCHER_ILLUSTRATION_COMPONENT_PROPS = {
    height: '120px',
    width: '120px',
  },
  AUTH_WATCHER_MODAL_ILLUSTRATIONS = {
    [AuthScenariosEnumeration.ABOUT_EXPIRING]: 'illustration_L3_security_leave-default',
    [AuthScenariosEnumeration.ACCESS]: 'illustration_feedback_attention',
    [AuthScenariosEnumeration.REFRESH]: 'illustration_feedback_attention',
    [AuthScenariosEnumeration.REDIRECTING]: 'illustration_emptystates_on-hold',
  };

export {
  AUTH_WATCHER_MODAL_COMPONENT_PROPS,
  AUTH_WATCHER_ILLUSTRATION_COMPONENT_PROPS,
  AUTH_WATCHER_MODAL_TITLE_COMPONENT_PROPS,
  AUTH_WATCHER_MODAL_ILLUSTRATIONS,
};
